import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  CreateQueryScheduleRequestSchema,
  EditQueryScheduleRequestSchema,
  QueryScheduleSchema,
} from '../shared/schemas/QueryScheduleeSchema.js';

const STALE_5_MIN = 1_000 * 60 * 5;

export type CreateScheduleRequestType = z.infer<
  typeof CreateQueryScheduleRequestSchema
>;

export type QueryScheduleSchemaType = z.infer<typeof QueryScheduleSchema>;

export const listQuerySchedule = defaultApi.declareEndpoint({
  url: 'ai-assistant/schedules' as const,
  method: 'GET',
  responseSchema: z.array(QueryScheduleSchema),
});

export const getScheduleOptions = makeQueryOptions(
  listQuerySchedule,
  {
    processResponse(data) {
      return data;
    },
  },
  { staleTime: STALE_5_MIN },
);

export const createQuerySchedule = defaultApi.declareEndpoint({
  url: 'ai-assistant/schedules' as const,
  method: 'POST',
  requestSchema: CreateQueryScheduleRequestSchema,
  responseSchema: QueryScheduleSchema,
});

export const editQuerySchedule = defaultApi.declareEndpoint({
  url: 'ai-assistant/schedules/$scheduledQueryId' as const,
  method: 'PATCH',
  requestSchema: EditQueryScheduleRequestSchema,
  responseSchema: QueryScheduleSchema,
});

export const deleteQuerySchedule = defaultApi.declareEndpoint({
  url: 'ai-assistant/schedules/$scheduledQueryId' as const,
  method: 'DELETE',
  responseSchema: z.string(),
});
